import { INQUIRY_LINK } from 'static/constants'

export const getInquiryLink = () => {
  const path = INQUIRY_LINK
  return path
}
